import PropTypes from 'prop-types';
import React from 'react';
import { SelectSearch } from 'mol-ui';
import { useTranslation } from 'react-i18next';

const Filter = ({
    counter,
    filterOptions = [],
    handleFilter
}) => {

    const { t } = useTranslation();

    return (
        <SelectSearch
            options={ filterOptions }
            placeholder={ `${ t('Filtrar') }${ counter ? ` (${ counter })` : '' }` }
            width="120px"
            onChange={ handleFilter }
        />
    );
};

Filter.propTypes = {
    counter: PropTypes.number,
    filterOptions: PropTypes.array,
    handleFilter: PropTypes.func
};

export { Filter };
